export const PROPERTY_APT_RESIDENT_fi = {
  translation: {
    keys: {
      condominium: 'Kiinteistö',
      handoverInstructions: 'Avainluovutuksen ohjeet',
      handoverInstructionsPlaceholder: 'Kirjoita ohjeet avainten luovutukseen ja palautukseen',
    },
    key: {
      handoverAddFromDirectory: 'Kiinteistöstä tai asunnosta',
      handoverDirectoryHint:
        'Valitse kiinteistö tai asunto, tai kirjoita vähintään kaksi merkkiä hakukenttään (tunniste, osoite, kiinteistö).',
      handoverDirectoryNoQuery: 'Valitse kiinteistö tai asunto, tai kirjoita hakua (vähintään 2 merkkiä).',
    },
    apartments: {
      apartment: 'Asunto',
      condominium: 'Kiinteistö',
      selectCondominium: 'Valitse kiinteistö',
      condominiumRequired: 'Kiinteistö on pakollinen',
    },
    validation: {
      condominiumRequired: 'Kiinteistö vaaditaan',
    },
    wizard: {
      title: 'Kiinteistön pika-luonti',
      subtitle: 'Luo kiinteistö, asunnot, asukkaat ja avaimet kerralla',
      steps: {
        condominium: 'Kiinteistö',
      },
      stepDescriptions: {
        condominium: 'Luo uusi kiinteistö täyttämällä perustiedot',
        apartments: 'Lisää asuntoja kiinteistöön yksittäin tai massana',
      },
    },
    condominium: {
      header: 'Kiinteistöt',
      condominiums: 'Kiinteistöt',
      condominiumDetails: 'Kiinteistön tiedot',
      name: 'Kiinteistö',
      create: 'Luo kiinteistö',
      edit: 'Muokkaa kiinteistöä',
      update: 'Päivitä kiinteistö',
      deleteTitle: 'Poista kiinteistö',
      deleteMessage: 'Haluatko varmasti poistaa kiinteistön',
      searchPlaceholder: 'Hae kiinteistöjä...',
      nocondominiumsForSearch: 'Ei kiinteistöjä haulle "{{searchTerm}}"',
      nocondominiumsYet: 'Ei kiinteistöjä.',
      selectCondominium: 'Valitse kiinteistö',
      transfer: {
        toSubCompany: 'Siirrä aliyritykselle',
        transferredTooltip: 'Siirretty aliyritykselle',
        transferredTo: 'Siirretty yritykselle {{name}}',
        subCompanyCanEdit: 'Alayritys voi muokata siirrettyjä tietoja',
        revokeTransfer: 'Peruuta siirto',
        changeEditAccess: 'Muuta muokkausoikeutta',
        selectSubCompany: 'Valitse aliyritys',
        confirmTransfer: 'Vahvista siirto',
        transferSuccess: 'Siirto tehty',
        revokeConfirm: 'Haluatko varmasti peruuttaa siirron? Alayritys menettää pääsyn kiinteistöön.',
        transferredAt: 'Siirretty',
        back: 'Edellinen',
        next: 'Seuraava',
      },
    },
    controlPanel: {
      transferredCondominiums: 'Siirretyt kiinteistöt',
      personalDataPurge: {
        targetsHint: 'Henkilöt on valittu valmiiksi. Kiinteistöt, asunnot ja avaimet voi lisätä tarvittaessa.',
        propertyGroupHint: 'Kiinteistöt, asunnot ja avaimet siirtyvät samaan 7 päivän roskakoriin.',
        targetTypes: {
          condominium: 'Kiinteistöt',
        },
        fields: {
          condominiumId: 'Kiinteistö',
        },
        columns: {
          condominium: 'Kiinteistö',
        },
      },
    },
    messages: {
      condominiumCreated: 'Kiinteistö luotu onnistuneesti',
      condominiumUpdated: 'Kiinteistö päivitetty onnistuneesti',
      condominiumDeleted: 'Kiinteistö poistettu onnistuneesti',
      condominiumsDeletedBulk: '{{count}} kiinteistöä poistettu onnistuneesti',
      condominiumCreateFailed: 'Kiinteistön luonti epäonnistui',
      condominiumUpdateFailed: 'Kiinteistön päivitys epäonnistui',
      condominiumDeleteFailed: 'Kiinteistön poisto epäonnistui',
    },
    dashboard: {
      myManagedProperties: 'Hallinnoimani kiinteistöt',
      noProperties: 'Ei näytettäviä kiinteistöjä',
    },
    properties: {
      tabProperties: 'Kiinteistöt',
      tabApartments: 'Asunnot',
      createProperty: 'Luo kiinteistö',
    },
    general: {
      showBulkDelete: 'Näytä massapoisto-taulukoissa',
      showBulkDeleteDescription:
        'Mahdollistaa usean kohteen valinnan ja poiston asunnoissa, asukkaissa, kiinteistöissä ja avaimissa.',
    },
    actions: {
      bulk: {
        deleteCondominiumsMessage: 'Haluatko varmasti poistaa {{count}} valittua kiinteistöä?',
        editCondominiumsTitle: 'Muokkaa kiinteistöjä',
      },
    },
    tooltips: {
      keys: {
        handoverInstructions:
          'Näytetään avainten luovutuksen ja palautuksen yhteydessä. Voit määrittää ohjeet yritys-, laskutus-, kiinteistö- ja asuntotasolla; alempi taso ylikirjoittaa ylemmän.',
      },
      wizard: {
        superintendent:
          'Hallinnoija on henkilö, joka vastaa kiinteistön päivittäisestä hallinnasta ja kunnossapidosta.',
      },
      condominium: {
        businessId:
          'Suomalainen Y-tunnus muodossa 1234567-8. Valinnainen, mutta suositeltu virallisille kiinteistöille.',
      },
      settings: {
        showMyProperties: 'Näytä kiinteistöt, joissa olet listattu hallinnoijaksi tai sinulla on erikoisoikeudet.',
        showBulkDelete:
          'Mahdollistaa usean kohteen valinnan ja massapoiston taulukoissa (asunnot, asukkaat, kiinteistöt, avaimet).',
      },
    },
    import: {
      condominiums: 'Kiinteistöt',
      condominiumsInstructions: 'Tuo kiinteistöjä',
      apartmentsInstructionsDescription: 'Osoite ja kiinteistö ovat pakollisia tietoja.',
      apartmentsFieldCondominium: 'Kiinteistö: Olemassa olevan kiinteistön nimi',
      keysFieldCondominium: 'Kiinteistö: Olemassa olevan kiinteistön nimi (vain yleisille avaimille)',
      errors: {
        condominiumNotFound: 'Ei löytynyt',
        condominiumRequiredForGeneral: 'Kiinteistö vaaditaan yleisille avaimille',
        condominiumNotAllowedForNonGeneral: 'Kiinteistöä ei voi määrittää avaimille, jotka eivät ole yleisiä avaimia',
      },
    },
    invitations: {
      condominium: 'Kiinteistö',
      apartment: 'Asunto',
    },
    contractor: {
      property: 'Kiinteistö',
      apartment: 'Asunto',
      selectProperty: 'Valitse kiinteistö',
      selectApartment: 'Valitse asunto',
      keyAccessFilterCondominiumPlaceholder: 'Kaikki kiinteistöt',
      keyAccessFilterApartmentPlaceholder: 'Kaikki asunnot',
    },
    contractorDashboard: {
      properties: 'Kiinteistöt',
      apartments: 'Asunnot',
    },
    documentBank: {
      searchPlaceholder: 'Hae kiinteistöä, asuntoa tai asiakkuutta…',
      sections: {
        condominiums: 'Kiinteistöt',
      },
    },
    events: {
      entityType: {
        resident: 'Asukas',
        apartment: 'Asunto',
        condominium: 'Kiinteistö',
        key: 'Avain',
        landlord: 'Vuokranantaja',
      },
    },
    reports: {
      totalCondominiums: 'Kiinteistöt',
    },
    billing: {
      auditCondominium: 'Kiinteistöt',
      auditApartment: 'Asunnot',
      auditResident: 'Asukkaat',
      auditKey: 'Avaimet',
    },
    landlordPortal: {
      allApartmentsOption: 'Kaikki asunnot',
    },
    residentNotifications: {
      scope: {
        wholeCondominium: 'Koko kiinteistö',
      },
      field: {
        wholeCondominium: 'Koko kiinteistö',
        wholeCondominiumHelp: 'Ilmoitus näkyy kaikille kiinteistön asunnoille asukas- ja vuokranantajaportaalissa.',
      },
      validation: {
        apartments: 'Valitse vähintään yksi asunto tai koko kiinteistö.',
      },
    },
    maintenance: {
      needsAssessment: {
        selectCondominium: 'Valitse kiinteistö suodattaaksesi listaa.',
      },
    },
    upkeep: {
      selectCondominiums: 'Valitse kiinteistöt',
      multiBatchAllApartmentsHelp: 'Jokaiseen valittuun kiinteistöön luodaan rivit kaikille asunnoille.',
      filterCondominiums: 'Suodata kiinteistöjä',
      filterCondominiumsPlaceholder: 'Kirjoita kiinteistön nimi tai osoite',
      sendResidentNotificationHelp:
        'Sama ilmoitus lähetetään valittujen kiinteistöjen asukkaille (ja näkyy portaaleissa).',
      wizardStepLocationHelp:
        'Valitse kiinteistö ja tarvittaessa asunto. Jos asuntoa ei valita, voit valita useita asuntoja kerralla.',
      wizardStepLocationHelpEquipment:
        'Valitse kiinteistö ja tarvittaessa asunto. Jos asuntoa ei valita, valitset asunnot seuraavassa vaiheessa laitteiden kanssa.',
      locationProperty: 'Kiinteistö',
      locationSpace: 'Asunto',
      trackedAssetsEmpty: 'Ei laitteita valitulla kiinteistöllä',
      noApartmentsForProperty: 'Kiinteistöllä ei ole asuntoja',
    },
    trackedAssets: {
      columnCondominium: 'Kiinteistö',
      filterCondominium: 'Suodata kiinteistö',
      selectCondominium: 'Valitse kiinteistö',
      mapEmptyHint: 'Lisää laitteelle kiinteistö tai asunto, jossa on osoite.',
      bulkCreateUpkeepSameCondo: 'Valitse vain saman kiinteistön laitteita.',
    },
    residentPortal: {
      filesSectionTitle: 'Asunnon ja kiinteistön tiedostot',
    },
  },
};
